'use client';

import { Box, entityIcon } from '@terra/ui-styled-system';
import type { TerraIcon } from '@terra/ui-icons';

export type EntityIconAppearance = 'default' | 'highlighted' | 'muted';

export type EntityIconDensity = 'compact' | 'default' | 'large';

type EntityIconBaseProps = {
  icon: TerraIcon;
  bg?: string;
  color?: string;
  borderColor?: string;
  appearance?: EntityIconAppearance;
  density?: EntityIconDensity;
};

export function EntityIconBase({
  icon: Icon,
  bg,
  color,
  borderColor,
  appearance = 'default',
  density = 'default',
}: EntityIconBaseProps) {
  const appearanceValues = {
    default: {
      bg: 'bg.default',
      color: 'fg.neutral.muted',
      borderColor: 'border.neutral.disabled',
    },
    muted: {
      bg: 'bg.neutral.subtle',
      color: 'fg.neutral.disabled',
      borderColor: 'border.neutral.subtle',
    },
    highlighted: {
      bg: bg ?? 'bg.default',
      color: color ?? 'fg.neutral.muted',
      borderColor: borderColor ?? 'border.neutral.disabled',
    },
  } as const;
  const resolvedAppearanceValues = appearanceValues[appearance];

  return (
    <Box
      className={entityIcon({ appearance, density }).root}
      bg={resolvedAppearanceValues.bg}
      color={resolvedAppearanceValues.color}
      borderColor={resolvedAppearanceValues.borderColor}
    >
      <Icon size={16} />
    </Box>
  );
}
